var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.loggedIn && _vm.loaded)?[(_vm.isNewUser)?_c('NovoUsuario'):[_c('Menu'),_c('v-main',[_c('v-container',[_c('router-view')],1)],1)]]:[_c('Load')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }